import React from 'react';
import RealEstateManagingPartnerProperties from './RealEstateManagingPartnerProperties';

// Simplified Properties - Always renders the Real Estate Managing Partner Properties
const Properties = () => {
  return <RealEstateManagingPartnerProperties />;
};

export default Properties;
